// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module--form--3LqoP","button":"styles-module--button--17MDf"};